import React from 'react'
import styled from 'styled-components'
import Text from './Text'

const Bold = styled(Text).attrs(({as = 'strong'}) => ({
  as,
}))`
  font-weight: 700;
`

export default Bold
